module.exports = __webpack_public_path__ + "media/3_7.82db8c94.wav";